import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class ExchangeRate {
  @IsString()
  @Expose()
  currencyCode!: string;
  @IsString()
  @Expose()
  currencyName!: string;
  @IsString()
  @Expose()
  exchangeDate!: string;
  @IsNumber()
  @Expose()
  exchangeRateValue!: number;
}
